export default __webpack_public_path__ + "static/media/poi-id.54a95594.png";